import { PreferredLanguage } from '@/data/enums';

export const getPreferredLang = (lang: string) => {
  return (
    {
      en: PreferredLanguage.English,
      my: PreferredLanguage.BahasaMalaysia,
    }[lang] ?? PreferredLanguage.English
  );
};
